import React from "react";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import { Text, TextProps } from "./Text";

const skewedRootVariants = cva("inline-block -skew-x-[7.125deg] px-2", {
  variants: {
    color: {
      primary: "bg-primary text-primary-contrast",
      secondary: "bg-secondary text-secondary-contrast",
      light: "bg-steel-100 text-steel-900",
      dark: "bg-steel-900 text-steel-100",
      theme: "bg-page text-page-contrast",
    },
  },
  defaultVariants: {
    color: "primary",
  },
});

const skewedInnerVariants = cva(
  "inline-block skew-x-[7.125deg] text-center italic font-semibold bg-inherit",
);

interface SkewedTextBoxProps extends Omit<TextProps, "color"> {
  color?: "primary" | "secondary" | "light" | "dark" | "theme";
  children: React.ReactNode;
}

export const SkewedTextBox = (props: SkewedTextBoxProps) => {
  const { color = "primary", className, ...rest } = props;
  return (
    <div className={clsx(skewedRootVariants({ color }), className)}>
      <Text {...rest} className={skewedInnerVariants()} />
    </div>
  );
};
